<!-- src/app/components/view-token-modal/view-token-modal.component.html -->
<div class="modal-header">
  <h4 class="modal-title">View Token</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <p class="token-text"><strong>Token Value:</strong> {{ token.token }}</p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">Close</button>
</div>
